import Swiper from 'swiper/bundle';
import { $Q } from '../utils/query-selector';
import 'swiper/css/bundle';

const initCollectionNavCarousel = () => {
  const collectionCarousel = $Q('.collection-nav-swiper');

  if (!collectionCarousel) return;

  const swiper = new Swiper(collectionCarousel, {
    slidesPerView: 6,
    breakpoints: {
      280: {
        slidesPerView: 3.5,
        spaceBetween: 8,
      },
      640: {
        slidesPerView: 3.5,
      },
      768: {
        slidesPerView: 6,
      },
      992: {
        slidesPerView: 6,
      },
    },
    spaceBetween: 16
  });
}

export default initCollectionNavCarousel;